module.exports = {"title":"Free International Courier Deliveries","image":"/media/shipping_cover.jpg","overlap":true,"trustpilot":true}